import { Grid } from '@material-ui/core';
import { PermIdentityOutlined, ExpandMore } from '@material-ui/icons';
import { isEmptyString, isNumber } from '@roc/feature-utils';
import { formatPercentage } from '@roc/ui/utils';
import { ItemDisplay } from 'libs/feature-one-tool/src/quote/components/itemDisplay';
import { PercentagePicker } from 'libs/feature-one-tool/src/quote/steps/leverage/components/leverageComponents';
import { getBooleanDisplayValue } from 'libs/feature-one-tool/src/quote/utils/utils';
import { observer } from 'mobx-react';
import { useLoanTypeStore } from '../../../hooks/useLoanTypeStore';
import { RoundedBackgroundIcon } from './roundedBackgroundIcon';

export const BorrowerInformationAccordionSummary = observer(
  ({
    borrowerFormStore,
    showOwnershipPct = true,
    showOwnershipPicker = false,
  }) => {
    const { loanTypeStore } = useLoanTypeStore();

    const borrower = borrowerFormStore.getFormValues();
    let fullName = `${borrower.firstName} ${borrower.lastName}`.trim();
    if (fullName === '') {
      fullName = '-';
    }
    const ficoScore = borrower.ficoProvidedAtOrigination ? borrower.ficoProvidedAtOrigination : 0;
    let experienceTier = borrower.rentalExperience;

    const personalGuarantor = getBooleanDisplayValue(
      borrower.personalGuarantor
    );
    const percentageOfOwnership = isNumber(borrower.percentageOfOwnership)
      ? formatPercentage(borrower.percentageOfOwnership)
      : '-';

    return (
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={5}>
          <Grid
            container
            spacing={2}
            justifyContent="flex-start"
            alignItems="center"
            style={{ flexWrap: 'nowrap' }}
          >
            <Grid item alignItems="center" style={{ height: '100%' }}>
              <RoundedBackgroundIcon
                Icon={PermIdentityOutlined}
                iconColor="#6D6D6D"
              />
            </Grid>
            <Grid item style={{ maxWidth: '100%' }}>
              <ItemDisplay
                label="Borrower Name"
                value={fullName}
                alignItems="flex-start"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={7}>
          <Grid
            container
            spacing={3}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Grid item>
              <ItemDisplay label="FICO Score" value={ficoScore} />
            </Grid>
            <Grid item>
              <ItemDisplay
                label="Experience Tier"
                value={experienceTier || '-'}
              />
            </Grid>
            <Grid item>
              <ItemDisplay
                label="Personal Guarantor"
                value={personalGuarantor}
              />
            </Grid>
            {showOwnershipPct && (
              <Grid item>
                <ItemDisplay label="Owner %" value={percentageOfOwnership} />
              </Grid>
            )}
            {showOwnershipPicker && (
              <PercentagePicker
                label="Ownership Percentage"
                fieldName="pctOwnership"
                value={borrowerFormStore.form.fields.pctOwnership.value}
                onChange={val =>
                  borrowerFormStore.onFieldChange('pctOwnership', val)
                }
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  }
);
